module.exports = __webpack_public_path__ + "static/09-3-a79ced435a86f6088ba4883fdde7da32.jpg";